import { motion } from "framer-motion";
import { ClipboardCheck, MessageSquareText, PhoneCall, Truck } from "lucide-react";
import Reveal, { ChapterTag } from "./Reveal";

const STEPS = [
  {
    icon: PhoneCall,
    title: "Call or WhatsApp",
    desc: "Reach us anytime — we pick up fast.",
  },
  {
    icon: MessageSquareText,
    title: "Share Scrap Details",
    desc: "Type, quantity, location — a quick photo helps.",
  },
  {
    icon: ClipboardCheck,
    title: "Get Instant Quote",
    desc: "Live rates, no haggling, no surprises.",
  },
  {
    icon: Truck,
    title: "Pickup & Payment",
    desc: "We arrive, weigh, pay — same day, every time.",
  },
];

export default function HowItWorks() {
  return (
    <section id="process" data-testid="process-section" className="scroll-mt-24 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <ChapterTag index="03" label="How It Works" />
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-bold tracking-tight text-ink sm:text-5xl">
            Sell scrap in <span className="text-mint-dark">4 simple steps.</span>
          </h2>
        </Reveal>

        <div className="relative mt-16">
          <div
            className="absolute left-0 right-0 top-8 hidden border-t-2 border-dashed border-line lg:block"
            aria-hidden="true"
          />
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
            {STEPS.map((step, i) => {
              const Icon = step.icon;
              return (
                <motion.div
                  key={step.title}
                  initial={{ opacity: 0, y: 36 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1], delay: i * 0.15 }}
                  data-testid={`process-step-${i + 1}`}
                  className="group relative"
                >
                  <div className="relative z-10 flex h-16 w-16 items-center justify-center rounded-2xl bg-green-50 transition-colors duration-300 group-hover:bg-brand">
                    <Icon className="h-7 w-7 text-brand transition-colors duration-300 group-hover:text-white" />
                  </div>
                  <p className="mt-6 font-display text-5xl font-extrabold text-brand/20">
                    {String(i + 1).padStart(2, "0")}
                  </p>
                  <h3 className="mt-3 font-display text-xl font-bold tracking-tight text-ink">
                    {step.title}
                  </h3>
                  <p className="mt-2 max-w-xs text-sm leading-relaxed text-steel">{step.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
